//utils
import { timeFormat } from '../../../utils/dateFormat';
import Button from '../../CustomButton/CustomButton.jsx';

function Intersection({ userPromptModal, t, dateTimeRules, options, commonStore }) {
    if (!userPromptModal.sourceInfo.intersection) return null;

    const { timesheetIntersection, absenceIntersection, vacationIntersection } = userPromptModal.sourceInfo.intersection;

    return (
        <div style={{ maxHeight: "400px", overflowY: "auto" }}>
            {/* ================= TIMESHEETS ================= */}
            {timesheetIntersection && (
                <div>
                    <div className="fw-bold text-danger">
                        {timesheetIntersection.error}
                    </div>

                    <div className="row timelog-grid-time-card">
                        <table className="table mt-0">
                            <thead>
                                <tr>
                                    <th>{t('Date')}</th>
                                    <th>{t('Start Time')}</th>
                                    <th>{t('End Time')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {timesheetIntersection.timesheets.map(ts => (
                                    <tr key={ts.id}>
                                        <td style={{ width: '40%', textAlign: 'left', paddingLeft: '57px' }}>{ts.status === 'draft' ? `${ts.from_date} (${t('At work')})` : `${ts.from_date}`}</td>
                                        <td>{timeFormat(ts.start_time, dateTimeRules)}</td>
                                        <td>{timeFormat(ts.end_time, dateTimeRules)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            {/* ================= ABSENCES ================= */}
            {absenceIntersection && (
                <div>
                    <div className="fw-bold text-danger">
                        {absenceIntersection.error}
                    </div>

                    <div className="row timelog-grid-time-card">
                        <table className="table mt-0">
                            <thead>
                                <tr>
                                    <th>{t('Type')}</th>
                                    <th>{t('Date')}</th>
                                    <th>{t('Time')}</th>
                                    <th>{t('Total days')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {absenceIntersection.absences.map(abs => (
                                    <tr key={abs.id}>
                                        <td title={t(commonStore.getAbsenceTypeLabel(abs.type))}>
                                            {t(commonStore.getAbsenceTypeLabel(abs.type)).length > 20
                                                ? t(commonStore.getAbsenceTypeLabel(abs.type)).substring(0, 20) + "..."
                                                : t(commonStore.getAbsenceTypeLabel(abs.type))}
                                        </td>
                                        <td>{abs.from_date} | {abs.to_date}</td>
                                        <td>
                                            {abs.start_time !== null && abs.end_time !== null
                                                ? `${timeFormat(abs.start_time, dateTimeRules)} - ${timeFormat(abs.end_time, dateTimeRules)}`
                                                : '-'}
                                        </td>
                                        <td>
                                            {abs.employement_grade < 100
                                                ? `${abs.total_days} d (${abs.hours} h)` // `${abs.hours} H | ${abs.total_days} D`
                                                : `${abs.total_days} d`}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            {/* ================= VACATIONS ================= */}
            {vacationIntersection && (
                <div>
                    <div className="fw-bold text-danger">
                        {vacationIntersection.error}
                    </div>

                    <div className="row timelog-grid-time-card">
                        <table className="table mt-0">
                            <thead>
                                <tr>
                                    <th>{t('From Date')}</th>
                                    <th>{t('To Date')}</th>
                                    <th>{t('Total days')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {vacationIntersection.vacations.map((vac, index) => (
                                    <tr key={index}>
                                        <td>{vac.from_date}</td>
                                        <td>{vac.to_date}</td>
                                        <td>{vac.total_days}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
            {
                userPromptModal.actions && userPromptModal.actions.some(ele => ele.action === 'REGISTER_MANDATORY_TIMESHEET') && (
                    <div className="d-flex justify-content-end mt-3 mb-1">
                        <Button fill wd onClick={userPromptModal.actionMethods.handleRegisterWithMandatory}>
                            {t('Register as Mandatory Overtime/Flexitime')}
                        </Button>
                    </div>
                )
            }
            {
                userPromptModal.actions && userPromptModal.actions.some(ele => ele.action === 'PROCEED_WITH_MANDATORY_TIMESHEET') && (
                    <div className="d-flex justify-content-end mt-3 mb-1">
                        <Button fill success wd onClick={userPromptModal.actionMethods.handleAbsenceWithMandatoryOvertimeFlexitime}>
                            {t('Proceed as Mandatory Overtime/Flexitime')}
                        </Button>
                    </div>
                )
            }
        </div>
    );
}

export {
    Intersection
};